import { LOCAL_STORAGE_KEY } from '@orcar/common-d2c';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { trackReferralLinkOpened } from '@/utils/analytics';

/**
 * 초대 링크(/invite/:code) 진입점.
 * 추천코드를 보관하고 홈으로 보낸다. 로그인 시 usePendingReferral이 자동 적용한다.
 */
const InvitePage = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      const normalized = code.trim().toUpperCase();
      localStorage.setItem(LOCAL_STORAGE_KEY.REFERRAL_PENDING, normalized);
      trackReferralLinkOpened({
        referral_code: normalized,
        referral_source: 'invite_link',
      });
    }
    navigate('/', { replace: true });
  }, [code, navigate]);

  return null;
};

export default InvitePage;
